import { useState, useEffect } from 'react';
import {useNavigate,  useParams } from "react-router-dom";
import { Row, Col, Card, Input, Button, theme, Select } from "antd";
import BreadcrumbList from "../../../../Shared/Components/Breadcrumb/Breadcrumb";
import { alertService } from "../../../../Shared/Utils/ToasterUtils";
import { ServiceUtils } from "../../../../Shared/Utils/ServiceUtils";

export default function CreateFollowUp() {

  const navigate = useNavigate();
  const { TextArea } = Input;
  const [isEditEnabled, setIsEditEnabled] = useState(false);
  const [loader, setLoader] = useState(true);
  const [inputs, setInputs] = useState();
  const { token } = theme.useToken();
  const [actionDetails, setActionDetails] = useState({
    followup_type: [
      { label: "General", value: "General" },
      { label: "Conference", value: "Conference" },
      { label: "Meeting", value: "Meeting" },
    ],
    action_on: [],
    action_assigned_to: [],
    action_status: []
  });
  const { followup_id } = useParams();
  const contentStyle = {
    color: token.colorTextTertiary,
    backgroundColor: token.colorFillAlter,
    borderRadius: token.borderRadiusLG,
    border: `1px dashed ${token.colorBorder}`,
    marginTop: 16,
    height: "calc(100vh - 230px)",
    overflow: "auto"
  };
  

  useEffect(() => {
    if (followup_id) {
      getDetailsToEdit(followup_id);
    }
  }, [followup_id]);

  const getDetailsToEdit = (id) => {
    try {
      let payload = {
        followupId: id
      };
      ServiceUtils.postRequest("viewFollowup", payload).then(
        (_response) => {
          if (_response.status === 200) {
            if (_response?.data) {
              // Prefill the form fields if edit id exists
              setInputs({
                followup_type: _response.data.data.followup_type || "",
                action_on: _response.data.data.action_on || "",
                action_assigned_to: _response.data.data.action_assigned_to || "",
                action_status: _response.data.data.action_status || "",
                followup_notes: _response.data.data.followup_notes || "",
                conference: _response.data.data.conference || "",
                meeting: _response.data.data.meeting || ""
              });
              // setIsEditEnabled(true); // Mark as edit mode
              if (_response.data.data.followup_type === "Conference" || _response.data.data.followup_type === "Meeting") {
                fetchFollowupData({ type: "edit", editData: _response.data.data });
              }
              setLoader(false);
            }
          }
        },
        (error) => {
          console.log("Error in fetching data", error);
        }
      )
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    fetchData();
  }, [])

  /**
   * To fetch dropdown options on initial page load
   */
  const fetchData = () => {
    try {
      let payload = {
        meetingId: null
      };
      ServiceUtils.postRequest("actions", payload).then(
        (_response) => {
          if (_response.status === 200) {
            if (_response?.data) {
              setActionDetails((prevDetails) => ({
                ...prevDetails,
                action_on: _response.data.data.action_on || [],
                action_assigned_to: _response.data.data.action_assigned_to || [],
                action_status: _response.data.data.action_status || []
              }));
              setLoader(false);
            }
          }
        },
        (error) => {
          console.log("Error : Dropdown data", error);
        }
      )
    } catch (error) {
      console.log(error);
    }
  }

  const handleChange = (value, key) => {
    setInputs((prevInputs) => ({
      ...prevInputs,
      [key]: value
    }));
    if (key === "followup_type" && (value === "Conference" || value === "Meeting")) {
      fetchFollowupData();
    }
    if (key === "conference" && inputs.followup_type === "Meeting") {
      fetchMeetingList(value);
    }
  };

  /**
   * To fetch dropdown options for Conference List dropdown
   * In case of edit scenario this function is used not only for fetching dropdown options but also for setting values for meeting and conference dropdowns
   * @param {{ type: "edit", editData: data from API }} val in case of edit scenario, passing followup data
   */
  const fetchFollowupData = (val) => {
    try {
      let payload = {
        "page": "followups"
      };
      ServiceUtils.postRequest("surveyConferences", payload).then(
        (_response) => {
          if (_response.status === 200) {
            if (_response?.data) {
              //first clear selected data and existing dropdown options ans then assign new options
              setInputs((prevInputs) => ({
                ...prevInputs,
                conference: undefined, // Clear selected conference
                meeting: undefined, // Clear selected meeting
              }));
              setActionDetails((prevDetails) => ({
                ...prevDetails, // Preserve previous details
                conferenceList: _response?.data?.data || [], // Update conference list
                meetingList: [], // Clear meeting list
              }));
              if (val && val.type === "edit") {
                // Update conference and meeting with the values from the edit data
                setInputs((prevInputs) => ({
                  ...prevInputs,
                  conference: val.editData.conference || "", // Set conference from edit data
                  meeting: val.editData.meeting || "", // Set meeting from edit data
                }));
                if (val.editData.followup_type === "Meeting") {
                  fetchMeetingList(val.editData.conference, val.editData.meeting);
                }
              }

            }

          }
        },
        (error) => {
          console.log("Error : Dropdown data", error);
        }
      )

    } catch (error) {
      console.error("Error fetching follow-up data:", error);
    }
  };

  const fetchMeetingList = (value, meetingId) => {
    try {
      let payload = {
        "page": "followups",
        "conferenceId": value
      };
      ServiceUtils.postRequest("surveyMeetings", payload).then(
        (_response) => {
          if (_response.status === 200) {
            if (_response?.data) {
              setActionDetails((prevDetails) => ({
                ...prevDetails,
                meetingList: _response?.data?.data
              }));
              if (meetingId) {
                setInputs((prevInputs) => ({
                  ...prevInputs,
                  meeting: meetingId || "", // Set meeting from edit data
                }));
              }
            }

          }
        },
        (error) => {
          console.log("Error : Dropdown data", error);
        }
      )

    } catch (error) {
      console.error("Error fetching follow-up data:", error);
    }
  }


  /**
   * To check if all input fields are filled or not and display error if any field is empty
   * @returns true or false
   */
  const validateInputs = () => {
    if (
      !inputs?.action_on ||
      !inputs?.action_assigned_to ||
      !inputs?.action_status ||
      !inputs?.followup_type ||
      !inputs?.followup_notes?.trim() ||
      (inputs?.followup_type === "Conference" && !inputs?.conference)
    ) {
      alertService.error("Please fill all required fields");
      return false;
    }
    return true; // Proceed with submission if all fields are filled
  };

  const SaveData = () => {
    try {
      if (validateInputs()) {
        let payload = {
          data: {
            ...inputs,
            created_time: new Date(), // Current timestamp
            created_timezone: Intl.DateTimeFormat().resolvedOptions().timeZone, // Time zone
          }
        };
        //for edit scenario
        if (followup_id) {
          payload.data = {
            ...payload.data,
            followup_id,  // Add followup_id inside data
            type: "edit"  // Add type as "edit" inside data
          };
        }
        ServiceUtils.postRequest("saveFollowup", payload).then(
          (_response) => {
            if (_response.status === 200 && _response.data.status === true) {
              alertService.success(_response.data.message);
              let { conference, ...resetInputs } = inputs;
              // Reset form values
              setInputs({
                action_on: "",
                action_assigned_to: "",
                action_status: "",
                followup_type: "",
                followup_notes: "",
                ...resetInputs // This ensures "conference" key is removed
              });
              navigateBack();
            } else {
              alertService.error(_response.data.message);
            }
          },
          (error) => {
            console.log("Error in saving data", error);
          }
        )
      }
    } catch (error) {
      console.log(error);
    }
  }

  /**
   * On click of cancel button navigate back to home
   */
  const navigateBack = () => {
    navigate("/home/followUp");
  }

  return (
    <>
      <div className="create-followup">
        <Card
          style={{ width: "100%", height: "fit-content" }}
          bodyStyle={{ padding: "10px" }}
        >
          <BreadcrumbList active={[{ label: "FollowUp", link: "/home/followUp" }, { label: followup_id ? "Edit FollowUp" : "Create FollowUp", link: "" }]} />
        </Card>
        {!loader &&
          <div className="list-container">
            <Card className="engagement-card">
              {!isEditEnabled ? (
                <>
                  <div style={contentStyle} >
                    <div style={{ padding: "5px" }}>
                      <div className="first-step">
                        <Row style={{ padding: "5px" }}>
                          <Col
                            className="form-group "
                            xs={{ flex: "100%" }}
                            sm={{ flex: "100%" }}
                            md={{ flex: "50%" }}
                            lg={{ flex: "25%" }}
                            xl={{ flex: "25%" }}
                          >
                            <div style={{ display: "grid", width: "90%" }}>
                              <div style={{ display: "flex" }}>
                                <label class="form-label text-ellipsis-one-line">
                                  Followup Type
                                </label>
                                <span className="text-mandatory">*</span>
                              </div>

                              <div className="action-on">
                                <Select
                                  placeholder="Select Action on"
                                  defaultValue={inputs?.followup_type || undefined}
                                  value={inputs?.followup_type || undefined}
                                  style={{ width: "100%" }}
                                  maxTagCount="responsive"
                                  onChange={(value) => handleChange(value, "followup_type")}
                                >
                                  {actionDetails?.followup_type?.length > 0 &&
                                    actionDetails.followup_type.map((el) => (
                                      <Select.Option key={el.value} value={el.value}>
                                        {el.label}
                                      </Select.Option>
                                    ))}
                                </Select>
                              </div>
                            </div>
                          </Col>

                          {(inputs?.followup_type === "Conference" || inputs?.followup_type === "Meeting") &&
                            <Col
                              className="form-group "
                              xs={{ flex: "100%" }}
                              sm={{ flex: "100%" }}
                              md={{ flex: "50%" }}
                              lg={{ flex: "25%" }}
                              xl={{ flex: "25%" }}
                            >
                              <div style={{ display: "grid", width: "90%" }}>
                                <div style={{ display: "flex" }}>
                                  <label class="form-label text-ellipsis-one-line">
                                    Conferences List
                                  </label>
                                  <span className="text-mandatory">*</span>
                                </div>

                                <div className="action-on">
                                  <Select
                                    placeholder="Select Conference"
                                    value={inputs?.conference || undefined}
                                    style={{ width: "100%" }}
                                    maxTagCount="responsive"
                                    onChange={(value) => handleChange(value, "conference")}
                                  >
                                    {actionDetails?.conferenceList?.length > 0 &&
                                      actionDetails.conferenceList.map((el) => (
                                        <Select.Option key={el.value} value={el.value}>
                                          {el.label}
                                        </Select.Option>
                                      ))}
                                  </Select>
                                </div>
                              </div>
                            </Col>
                          }
                          {(inputs?.followup_type === "Meeting" && actionDetails?.meetingList?.length > 0) &&
                            <Col
                              className="form-group "
                              xs={{ flex: "100%" }}
                              sm={{ flex: "100%" }}
                              md={{ flex: "50%" }}
                              lg={{ flex: "25%" }}
                              xl={{ flex: "25%" }}
                            >
                              <div style={{ display: "grid", width: "90%" }}>
                                <div style={{ display: "flex" }}>
                                  <label class="form-label text-ellipsis-one-line">
                                    Meeting List
                                  </label>
                                  <span className="text-mandatory">*</span>
                                </div>

                                <div className="action-on">
                                  <Select
                                    placeholder="Select Meeting"
                                    value={inputs?.meeting || undefined}
                                    style={{ width: "100%" }}
                                    maxTagCount="responsive"
                                    onChange={(value) => handleChange(value, "meeting")}
                                  >
                                    {actionDetails?.meetingList?.length > 0 &&
                                      actionDetails.meetingList.map((el) => (
                                        <Select.Option key={el.value} value={el.value}>
                                          {el.label}
                                        </Select.Option>
                                      ))}
                                  </Select>
                                </div>
                              </div>
                            </Col>
                          }
                        </Row>
                        <Row style={{ padding: "5px" }}>
                          <Col
                            className="form-group "
                            xs={{ flex: "100%" }}
                            sm={{ flex: "100%" }}
                            md={{ flex: "50%" }}
                            lg={{ flex: "25%" }}
                            xl={{ flex: "25%" }}
                          >
                            <div style={{ display: "grid" }}>
                              <div style={{ display: "flex" }}>
                                <label class="form-label text-ellipsis-one-line">
                                  Action
                                </label>
                                <span className="text-mandatory">*</span>
                              </div>

                              <div className="action-on">
                                <Select
                                  placeholder="Select Action on"
                                  defaultValue={inputs?.action_on || undefined}
                                  value={inputs?.action_on || undefined}
                                  style={{ width: "90%" }}
                                  maxTagCount="responsive"
                                  onChange={(value) => handleChange(value, "action_on")}
                                >
                                  {actionDetails?.action_on?.length > 0 &&
                                    actionDetails.action_on.map((el) => (
                                      <Select.Option key={el.value} value={el.value}>
                                        {el.label}
                                      </Select.Option>
                                    ))}
                                </Select>
                              </div>
                            </div>
                          </Col>
                          <Col
                            className="form-group "
                            xs={{ flex: "100%" }}
                            sm={{ flex: "100%" }}
                            md={{ flex: "50%" }}
                            lg={{ flex: "25%" }}
                            xl={{ flex: "25%" }}
                          >
                            <div style={{ display: "grid" }}>
                              <div style={{ display: "flex" }}>
                                <label class="form-label text-ellipsis-one-line">
                                  Action Assigned To
                                </label>
                                <span className="text-mandatory">*</span>
                              </div>
                              <div className="action-on">
                                <Select
                                  placeholder="Select Action on"
                                  defaultValue={inputs?.action_on || undefined}
                                  value={inputs?.action_assigned_to || undefined}
                                  style={{ width: "90%" }}
                                  maxTagCount="responsive"
                                  onChange={(value) => handleChange(value, "action_assigned_to")}
                                >
                                  {actionDetails?.action_assigned_to?.length > 0 &&
                                    actionDetails.action_assigned_to.map((el) => (
                                      <Select.Option key={el.value} value={el.value}>
                                        {el.label}
                                      </Select.Option>
                                    ))}
                                </Select>
                              </div>
                            </div>
                          </Col>
                          <Col
                            className="form-group "
                            xs={{ flex: "100%" }}
                            sm={{ flex: "100%" }}
                            md={{ flex: "50%" }}
                            lg={{ flex: "25%" }}
                            xl={{ flex: "25%" }}
                          >
                            <div style={{ display: "grid" }}>
                              <div style={{ display: "flex" }}>
                                <label class="form-label text-ellipsis-one-line">
                                  Action Status
                                </label>
                                <span className="text-mandatory">*</span>
                              </div>

                              <div className="action-on">
                                <Select
                                  placeholder="Select Action on"
                                  defaultValue={inputs?.action_status || undefined}
                                  value={inputs?.action_status || undefined}
                                  style={{ width: "90%" }}
                                  maxTagCount="responsive"
                                  onChange={(value) => handleChange(value, "action_status")}
                                >
                                  {actionDetails?.action_status?.length > 0 &&
                                    actionDetails.action_status.map((el) => (
                                      <Select.Option key={el.value} value={el.value}>
                                        {el.label}
                                      </Select.Option>
                                    ))}
                                </Select>
                              </div>
                            </div>
                          </Col>
                          <Col
                            className="form-group "
                            xs={{ flex: "100%" }}
                            sm={{ flex: "100%" }}
                            md={{ flex: "50%" }}
                            lg={{ flex: "25%" }}
                            xl={{ flex: "25%" }}
                          >
                            <div style={{ display: "grid" }}>
                              <div style={{ display: "flex" }}>
                                <label class="form-label text-ellipsis-one-line">
                                  Follow Up Notes
                                </label>
                                <span className="text-mandatory">*</span>
                              </div>

                              <TextArea
                                // disabled={props?.followUpRequired}
                                rows={3}
                                // defaultValue={record?.followup_notes ? record?.followup_notes : undefined}
                                value={inputs?.followup_notes || undefined}
                                style={{ width: "90%" }}
                                maxLength={500}
                                placeholder="Follow Up Notes"
                                autoComplete='off'
                                autoSize={{ minRows: 2, maxRows: 6 }}
                                onChange={(e) => handleChange(e.target.value, "followup_notes")}
                              />

                            </div>
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </div>
                  <div style={{ marginTop: 24 }}>
                    <div className="submit-block">
                      <div style={{ paddingRight: "10px" }}>
                        <Button
                          className="edit-meet-button"
                          type="primary"
                          onClick={() =>
                            SaveData()
                          }
                        >
                          Save
                        </Button>
                      </div>
                      <Button
                        onClick={() => {
                          navigateBack()
                        }
                        }
                      >
                        Cancel
                      </Button>
                    </div>
                  </div>
                </>
              ) :
                (
                  <>{!isEditEnabled && !loader &&
                    <>
                    </>
                  }
                  </>
                )}
            </Card>
          </div>
        }
      </div>
    </>
  )
}
